import { withCatalogueServerSideProps } from "lib/serverSideProps/withCatalogue";
import { withServerSideCatalogue } from "lib/hoc/withServerSideCatalogue";
import { withServerSideProps } from "lib/serverSideProps/withServerSideProps";
import { withUserServerSideProps } from "lib/serverSideProps/withUser";
import { GetServerSidePropsContext } from "next/types";
import { ServicePage } from "screens/ServicePage";
import { withWebLayout } from "lib/hoc/withWebLayout";
import { withHOC } from "lib/hoc/withHOC";

export const getServerSideProps = withServerSideProps([
  async (context: GetServerSidePropsContext) => {
    const { categorySku } = (context.params ?? {}) as {
      [key: string]: string;
    };

    const catalogueProps = await withCatalogueServerSideProps(context);
    if (
      !catalogueProps.props.initialStore?.defaultCatalogue.items.some(
        ({ sku, parentSku, active }) =>
          sku === categorySku && !parentSku && active,
      )
    ) {
      return {
        notFound: true,
      };
    }

    return catalogueProps;
  },
  withUserServerSideProps,
]);

export default withHOC([withServerSideCatalogue, withWebLayout], ServicePage);
